import { useState, useEffect } from 'react';

const SOUND_MUTED_KEY = `bolzai_${import.meta.env.VITE_NAMESPACE}_soundMuted`;

export function useSoundMuted() {
  const [isMuted, setIsMuted] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;

    const saved = localStorage.getItem(SOUND_MUTED_KEY);
    return saved !== null ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem(SOUND_MUTED_KEY, JSON.stringify(isMuted));
  }, [isMuted]);

  const toggleMuted = () => {
    setIsMuted(prev => !prev);
  };

  return { isMuted, toggleMuted };
}
